var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    {
      staticClass: "dropdown-menu",
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _c("li", { staticClass: "head text-light bg-dark" }, [
        _vm._v("Meldingen (" + _vm._s(_vm.notifications.length) + ")")
      ]),
      _vm._v(" "),
      _vm._l(_vm.notifications, function(notification, index) {
        return _c(
          "li",
          {
            key: "notification-box-" + parseInt(index),
            class: [
              notification.read ? "notification-read text-secondary" : "",
              "notification-box",
              "border-bottom"
            ],
            on: {
              click: function($event) {
                return _vm.redirectNotification(notification)
              }
            }
          },
          [
            _c("div", { staticClass: "notification" }, [
              _c("div", { staticClass: "notification__header" }, [
                _c("div", { staticClass: "notification__header__module" }, [
                  _c(
                    "div",
                    { staticClass: "notification__header__module__icon" },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: ["fad", notification.icon] }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "notification__header__module__name" },
                    [_vm._v(_vm._s(notification.moduleName))]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "notification__header__actions" },
                  [
                    !notification.read
                      ? _c("font-awesome-icon", {
                          staticClass: "text-primary",
                          attrs: { icon: ["fas", "circle"] }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !notification.needsResolve
                      ? _c(
                          "button",
                          {
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.resolveNotification(index)
                              }
                            }
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: ["far", "times"] }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "notification__message" }, [
                _vm._v(" " + _vm._s(notification.message) + " ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "notification__date" }, [
                _vm._v(_vm._s(notification.date))
              ])
            ])
          ]
        )
      }),
      _vm._v(" "),
      _vm.notifications.length === 0
        ? _c("li", { staticClass: "notification-box" }, [_vm._m(0)])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row py-3 px-3" }, [
      _c("span", { staticClass: "text-secondary col-sm-12" }, [
        _vm._v("U heeft op dit moment geen meldingen.")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }